import * as Yup from 'yup';
import { getBooleanSchema, getEmailSchema, getMaxStringSchema, getSelectSchema, getStringSchema } from 'src/compass/shared/schemas';

export const RequestTypeSchema = Yup.object().shape({
  name: getStringSchema(255, 'Name'),
  area: getSelectSchema('Area'),
  emailSubjectTemplate: getStringSchema(255, 'Subject'),
  emailBodyTemplate: getMaxStringSchema().required("Body is required."),
  fromAgent: getBooleanSchema("From Agent?"),
  cc: getEmailSchema('CC').notRequired(),
});
